import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrYT: CultureInfo = {
  name: 'fr-YT',
  displayName: 'français (Mayotte)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-YT',
  parent: CultureInfoFr
};
